import MixingFunctions from '../components/MixingFunctions';
import PartinerList from '../components/PartinerList';
import GridItens from '../components/template2/GridItens';
import ListItens from '../components/template2/ListItens';

new Vue({
    el: '#main-content',
    mixins: [
        MixingFunctions
    ],
    components: {
        'stretch': VueLoadingSpinner.Stretch,
        PartinerList,
        GridItens,
        ListItens
    },
    data: {
        ofertaOn: window.vueData.ofertaOn,
        lojas: window.vueData.lojas,
        marcasEspeciais: window.vueData.marcasEspeciais,
        corLoading: window.vueData.corLoading,
        bannersMeio: window.vueData.bannersMeio,
        // MUDANCA 1 (17/09/2026): banner do espaco antes do rodape
        bannersRodape: window.vueData.bannersRodape || [],
        bannersDestaque: window.vueData.bannersDestaque,
        bannersParceiros: window.vueData.bannersParceiros,
        bannersLateral: window.vueData.bannersLateral,
        storage: window.vueData.storage,
        baseLink: window.vueData.baseLink,
        totalCupons: window.vueData.totalCupons,
        totalMarcasBeneficionAtivo: window.vueData.totalMarcasBeneficionAtivo,
        totalMarcasParceiras: window.vueData.totalMarcasParceiras,
        totalCategorias: window.vueData.categorias.length,
        showOfertasEspeciais: window.vueData.showOfertasEspeciais,
        appendOnline: {
            limit: 12, // 18/09/2026: paginacao de 12 (pedido do Jonathan)
            tipoMarca: 'Online',
            removeTipo: true,
            home: true,
            homePaginada: true,
            escopo: 'item' // 18/09/2026: "Descontos por item" nao mostra os descontos da loja inteira
        },
        // 18/09/2026: "Descontos por lojas" (cupons e promocoes da loja inteira), 12 por pagina
        appendLojas: {
            limit: 12,
            escopo: 'loja'
        },
        appendFisica: {
            limit: 12,
            tipoMarca: 'Fisica',
            home: true
        },
        appendUltimas: {
            limit: 20,
            removeTipo: true,
            bestSellers: true,
            // home: true
        },
        params: {
            // MUDANCA 2 (17/09/2026): lista de marcas paginada de 8 em 8
            limit: 8,
            per_page: 8,
            start: true,
            able: true // Quantidade de itens maior que 1
        },
        // MUDANCA 3 (17/09/2026): texto "Exibindo x de y marcas" ao lado do titulo "Navegue por marca"
        exibindoMarcas: '',
        // 18/09/2026: mesmo cabecalho nas secoes de descontos
        exibindoLojas: '',
        exibindoItens: '',
        paramsEspeciais: {
            limit: 20,
            per_page: 20,
            start: true,
            tipoUtilizacao: true,
            verificado: true
        }
    },
    methods: {
        // MUDANCA 3 (17/09/2026): chamado SO pela lista de marcas (evento pagination-data), a cada pagina:
        // "Exibindo 9 a 16 de 52 marcas ativas."
        atualizaExibindo (paginationData) {
            if (!paginationData || !paginationData.total) {
                this.exibindoMarcas = '';
                return;
            }
            this.exibindoMarcas = 'Exibindo ' + (paginationData.from || 0) + ' a ' + (paginationData.to || 0)
                + ' de ' + paginationData.total + ' marcas ativas.';
        },
        // 18/09/2026: "Exibindo x a y de z ..." das secoes Descontos por lojas / Descontos por item
        textoExibindo (paginationData, final) {
            if (!paginationData || !paginationData.total) {
                return '';
            }
            return 'Exibindo ' + (paginationData.from || 0) + ' a ' + (paginationData.to || 0)
                + ' de ' + paginationData.total + ' ' + final;
        },
        atualizaExibindoLojas (paginationData) {
            this.exibindoLojas = this.textoExibindo(paginationData, 'descontos ativos.');
        },
        atualizaExibindoItens (paginationData) {
            this.exibindoItens = this.textoExibindo(paginationData, 'descontos em destaque.');
        },
        openBannerModal (item) {
            this.$refs.gridItens.$refs.vuetable.$refs.quick[0].checkClick(item);
        },
        openEspecial (item) {
            window.open(item, '_blank').focus();
        }
    }
});
